<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-psm-shijian2`]" width="1em" height="1em" v-bind="$attrs"><g :fill="useCurrentColor ? 'currentColor' : '#000'" fill-rule="evenodd"><path d="M56.0044437,10.1818679 C81.2063203,10.1818679 101.825727,30.8001743 101.825727,56.0003418 C101.825727,81.2003726 81.2063203,101.818269 56.0044437,101.818269 C30.8024304,101.818269 10.1826137,81.2003726 10.1826137,56.0003418 C10.1826137,30.8001743 30.8024304,10.1818679 56.0044437,10.1818679 L56.0044437,10.1818679 Z M56.0044437,0 C24.9471506,0 0,24.9453234 0,56.0003418 C0,87.0546766 24.9471506,112 56.0044437,112 C87.0610531,112 112.008204,87.0546766 112.008204,56.0003418 C112.008204,24.9453234 87.0610531,0 56.0044437,0 Z" transform="translate(8.992 9)"/><path d="M73.9836635,81 C72.4523593,81 71.1759524,80.4911291 70.1545802,79.2184049 L52.2846105,58.8546816 C51.5186842,58.090965 51.0082037,56.8182409 51.0082037,55.5456534 L51.0082037,30.0906232 C51.0082037,27.290466 53.3059828,25 56.1142423,25 C58.9218163,25 61.2195954,27.290466 61.2195954,30.0906232 L61.2195954,53.5092127 L77.8131582,72.345503 C79.6000454,74.3819437 79.3450109,77.6909719 77.3028148,79.4725669 C76.2814426,80.4911291 75.2604817,81 73.9836635,81 Z" transform="translate(8.992 9)"/></g></svg>
</template>
<script>

export default {
  name: 'IconPsmShijian2',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
